import {createAsyncThunk} from '@reduxjs/toolkit'
import {toast as message} from 'react-toastify'
import {getApi, patchApi, postApi} from '../../../axios'
import {API_ERROR} from '../../../global'
import { HNMS } from '../../../axios/services'



export const createHnms = createAsyncThunk('hnms/createhnms',
  async ({body, next = () => {}}, thunkAPI) => {
    try {
      const response = await postApi(HNMS, body)
      if (response?.data?.success) {
        message.success(response?.data?.message)
        return response?.data
      }
    } catch (error) {
      message.error(error?.response?.data?.message || API_ERROR)
      return thunkAPI.rejectWithValue(error.response.data.message)
    }
  }
)



export const patchHnms = createAsyncThunk(
  'hnms/patchHnms',
  async ({body, next = () => {}}, thunkAPI) => {
    try {
      const response = await patchApi(HNMS, body)
      if (response?.data?.success) {
        message.success(response?.data?.message)
        return response?.data
      }
    } catch (error) {
      message.error(error?.response?.data?.message || API_ERROR)
      return thunkAPI.rejectWithValue(error.response.data.message)
    }
  }
)





  export const getHnms = createAsyncThunk('hnms/getHnms',
        async (payload = {}, thunkAPI) => {
          console.log(payload,'payloadpayloadpayload')
          try {
            const params = {
              page: payload.page || 1,
              items_per_page: payload.items_per_page || 8,
              ...payload, 
            }
            console.log(params,'paramssssssssssssss')
          const queryString = new URLSearchParams(params).toString()
            
          const response = await getApi(`${HNMS}?${queryString}`)

          console.log(response,'responseresponse')
          if (response?.data?.success) {
              console.log(response.data,'response?.dataresponse?.data')
              console.log(response?.data?.data,'response?.dataresponse?.data')  
            return response?.data
          }
        } catch (error) {
          message.error(error?.response?.data?.message || API_ERROR)
          return thunkAPI.rejectWithValue(error.response.data.message)
        }
      })